module.exports = __webpack_public_path__ + "img/icon-revovery-success.37f655e2.png";